/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Materials of a bridge component
 */
export interface BridgeComponentMaterial { 
    /**
     * Internal ID
     */
    id?: number;
    /**
     * Internal bridge ID
     */
    bridgeComponentId: number;
    /**
     * Contains numeric properties about a bridge component material
     */
    numericProperties?: string;
    /**
     * Contains category information about a bridge component material
     */
    categories?: string;
    /**
     * Contains extra text information about a bridge component material
     */
    textProperties?: string;
}

